<template>
  <CheckoutCard>
    <div class="flex justify-between items-center">
      <h3 class="font-medium text-lg">
        {{ $t("Payment method") }}
        <Tooltip info="Required" position="right">*</Tooltip>
      </h3>
      <div
        class="flex items-center gap-1 text-muted-foreground cursor-pointer select-none"
        @click="showMoreInformation = !showMoreInformation">
        <div class="text-xs">{{ $t(!showMoreInformation ? "More information" : "Less information") }}</div>
        <InformationCircleIcon class="size-4" />
      </div>
    </div>
    <CheckoutInfo v-if="showMoreInformation">
      <div v-if="brandconfig.BRAND === 'demoshop'" class="flex flex-col gap-3">
        <div class="flex flex-col gap-3">
          <p>
            {{
              $t(
                "It is not possible to select a payment method in the demo shop. If you already have registered please check the email we sent you with further instructions to activate your account. Otherwise click here to sign-up"
              )
            }}
          </p>
          <a href="https://portal.xs2event.com/sign-up">
            <Button type="button"> {{ $t("Sign up") }} </Button>
          </a>
        </div>
      </div>
      <div v-else>
        {{
          $t(
            "Choose your preferred payment method. Additional costs may be charged depending on the chosen payment method"
          )
        }}
      </div>
    </CheckoutInfo>
    <p v-if="userStore.selectedCurrency !== 'EUR'" class="text-foreground mt-3 font-bold">
      {{ $t("Note") }}: {{ $t("Payments always need to be made in Euros") }}
    </p>
    <PaymentMethods v-if="useCartStore().timeLeft" />
    <Alert v-else status="warning">{{ $t("Your reservation has expired. Please update it and try again.") }}</Alert>
  </CheckoutCard>
</template>
<script setup lang="ts">
import { PaymentMethods } from "@/components/paymentmethods";
import { useUserStore } from "@/store/user.js";
import { Alert, Button, Tooltip } from "@xs2event/js-lib/components";
import brandconfig from "@/brandconfig";
import { InformationCircleIcon } from "@heroicons/vue/24/outline";
import { CheckoutCard } from ".";
import { useCartStore } from "@/store/cart";
import { ref } from "vue";
import CheckoutInfo from "./CheckoutInfo.vue";
const userStore = useUserStore();

const showMoreInformation = ref(false);
</script>
